export default __webpack_public_path__ + "static/media/white_prestashop.085d0a46.png";